module.exports = __webpack_public_path__ + "static/media/veryvell_4_filter.45c3e00b.png";